import React, { Component } from 'react';
import './style.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Star from '../../../_static/images/star.png';
import { MODAL_QUESTION_TRASHED_DELETE, showModal, MODAL_QUESTION_TRASHED_RECOVERY } from '../../../modules/modals';
// import { getQuiz } from '../../actions';
import { Checkbox as CheckboxInput } from 'antd';

const Checkbox = ({value, onChange, label}) => {
  return <div className="toggle-block toggle-block--indent-bottom">
    <div className="toggle-component">
      <span className={classNames("toggle-label", {active: !!value})}>{label}</span>
      <div className={classNames("react-toggle", {'react-toggle--checked': value})} onClick={() => {onChange(!value)}}>
        <div className="react-toggle-track">
          <div className="react-toggle-track-check"></div>
          <div className="react-toggle-track-x"></div>
        </div>
      <div className="react-toggle-thumb"></div>
    </div>
  </div>
  </div>
}

class Question extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
    super(props)
    this.state = {
      showAnswer: props.showAnswerParent,
      showExplanation: props.showDescriptionParent,
    }
  }

  getArrayAnswers = () => {
    const {question} = this.props;
    return Object.keys(question).filter(key => key.indexOf('answer_') > -1 && !!question[key]).map(key => ({value: question[key], active: question.correct_answer == key}))
  }

  UNSAFE_componentWillReceiveProps(nextProps){
    if(this.props.showAnswerParent != nextProps.showAnswerParent){
      this.setState({showAnswer: nextProps.showAnswerParent})
    }
    if(this.props.showDescriptionParent != nextProps.showDescriptionParent){
      this.setState({showExplanation: nextProps.showDescriptionParent})
    }
  }
  

  render() {
    const {question, isSelected, onSelect} = this.props;
    const {showAnswer, showExplanation} = this.state;
    const arrayChar = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    const {formatMessage} = this.context;

    return (
      <div >
        <div className="question-body_buttons pb-4 pt-4">
          <div className="question-component">
              <div className="question-body">
                <div className="question-text-html" dangerouslySetInnerHTML={{ __html: question.question }} />
                <Checkbox value={showAnswer} onChange={(value) => {
                  this.setState({showAnswer: value})
                }} label={formatMessage('hideAnswers')} />
                

                {showAnswer ? <div className="answers-block">
                  {this.getArrayAnswers().map((answer, index) => <div className={classNames("answer-component", {right: answer.active})}>
                    <div className="answer-label">{arrayChar[index]}</div>
                    <div className="answer-content">{answer.value}</div>
                  </div>)}
                </div> : null}

                <Checkbox value={showExplanation} onChange={(value) => {
                  this.setState({showExplanation: value})
                }} label={formatMessage('hideExplanation')} />

                {showExplanation ? <div className="question-text-html" dangerouslySetInnerHTML={{ __html: question.description }} /> : null}
              </div>
            </div>
              <div className="question-buttons">
                <div className='block'>
                  <CheckboxInput checked={isSelected} onChange={() => onSelect(question.id)} />
                </div>
              </div>
            </div>
          </div>
        
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  
})

const mapDispatchToProps = {
  showModal
}

export default connect(mapStateToProps, mapDispatchToProps)(Question)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionImport/components/Question.jsx